import { render, staticRenderFns } from "./acc-org.vue?vue&type=template&id=08a451d1&scoped=true&"
import script from "./acc-org.vue?vue&type=script&lang=js&"
export * from "./acc-org.vue?vue&type=script&lang=js&"
import style0 from "./acc-org.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./acc-org.vue?vue&type=style&index=1&id=08a451d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a451d1",
  null
  
)

export default component.exports